"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgSettings = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgSettings = function SvgSettings(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("path", {
    d: "M22.7 10.18a3 3 0 01-1.84-4.46c.48-.8.34-1.5-.14-1.97l-.47-.47c-.48-.48-1.17-.62-1.97-.14a3 3 0 01-4.46-1.84C13.59.39 13 0 12.33 0h-.66c-.68 0-1.27.39-1.49 1.3a3 3 0 01-4.46 1.84c-.8-.48-1.5-.34-1.97.14l-.47.47c-.48.48-.62 1.17-.14 1.97a3 3 0 01-1.84 4.46C.39 10.41 0 11 0 11.67v.66c0 .68.39 1.27 1.3 1.49a3 3 0 011.84 4.46c-.48.8-.34 1.5.14 1.97l.47.47c.48.48 1.17.62 1.97.14a3 3 0 014.46 1.84c.23.91.82 1.3 1.49 1.3h.66c.68 0 1.27-.39 1.49-1.3a3 3 0 014.46-1.84c.8.48 1.5.34 1.97-.14l.47-.47c.48-.48.62-1.17.14-1.97a3 3 0 011.84-4.46c.91-.23 1.3-.82 1.3-1.49v-.66c0-.68-.39-1.27-1.3-1.49zM12 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"
  }));
};

exports.SvgSettings = SvgSettings;
SvgSettings.isIcon = true;
SvgSettings.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgSettings;
exports["default"] = _default;